import { render } from "./ChooseWord.vue?vue&type=template&id=3b060841"
import script from "./ChooseWord.vue?vue&type=script&lang=js"
export * from "./ChooseWord.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Vue\\guesswhat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__